// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8297) return "static/chunks/8297.557b6792f27cc48f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1985":"2bfda41e3c0416d1","3800":"3c963decf49bf038","4534":"bf7d6f131c7d78f8","4550":"cdce6d99682a07ef","6462":"bed32894cbe0be84","6567":"2a9a7c124276624a","6877":"680a0915acfdfacb","7761":"8a27216f2dd8a2a7","7909":"7a5ba11d73561bd8","8887":"12b99c0c6eb0c3ca","9974":"cfea30f5f85b9dfa"}[chunkId] + ".js";
};